import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  CircularProgress,
  Typography,
  Alert,
  List,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CardRouter from '../cards/CardRouter';
import { useBuild } from '../contexts/BuildContext';


const SearchHitsDialog = ({ 
  open, 
  title = 'Search Results', 
  endpoint,
  payload,
  onClose 
}) => {
  const { searchApi } = useBuild();
  const [hits, setHits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open || !endpoint || !payload) {
      return;
    }

    const performSearch = async () => {
      setLoading(true);
      setError(null);
      setHits([]);

      try {
        const result = await searchApi.searchEphemeral(endpoint, payload);
        
        if (result.error) {
          setError(result.error);
        } else if (result.result && result.result.hits) {
          setHits(result.result.hits);
        } else {
          setError('No results found');
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch search results');
      } finally {
        setLoading(false);
      }
    };

    performSearch();
  }, [open, endpoint, payload, searchApi]);

  const renderContent = () => {
    if (loading) {
      return (
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          justifyContent: 'center',
          py: 4,
          gap: 2
        }}>
          <CircularProgress />
          <Typography variant="body2" color="text.secondary">
            Fetching results...
          </Typography>
        </Box>
      );
    }

    if (error) {
      return (
        <Alert severity="error" sx={{ my: 2 }}>
          <Typography variant="body2">
            Error: {error}
          </Typography>
        </Alert>
      );
    }

    if (hits.length === 0) {
      return (
        <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
          No results found.
        </Typography>
      );
    }

    return (
      <List sx={{ width: '100%' }}>
        {hits.map((hit, idx) => (
          <CardRouter key={idx} hit={hit} />
        ))}
      </List>
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}
        <IconButton
          onClick={onClose}
          sx={{ color: 'text.secondary' }}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {renderContent()}
      </DialogContent>
    </Dialog>
  );
};

export default SearchHitsDialog;

